export default "__VITE_ASSET__CemK6Dkj__"